import { useEffect } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { useRequest } from 'domain/core/hooks/useRequest';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { TUpdate } from 'domain/types';

export const useGetNotificationsSettings = () => {
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );

  const { data, isLoading } = useRequest({
    url: '/api/v1/notifications/settings',
    sendOnStart: true,
  });

  useEffect(() => {
    if (isLoading || !data) return;
    update?.({ notificationSettings: data });
  }, [data, isLoading, update]);

  return { isLoading };
};
